import { useSearchParams } from 'react-router';
import { Nullable } from '@xplan-pension-switching/common';
import { isNullOrUndefinedOrEmpty } from '../../helpers/IsNullOrUndefinedOrEmpty/IsNullOrUndefinedOrEmpty';

export const usePageSearchParams: () => {
    scenarioId: Nullable<number>;
    projectionId: Nullable<number>;
    ownerId: Nullable<number>;
    entityId: number;
} = () => {
    const [searchParams] = useSearchParams();
    const scenarioId = searchParams.get('scenarioId');
    const projectionId = searchParams.get('projectionId');
    const ownerId = searchParams.get('ownerId');
    const entityId = searchParams.get('entityid')!;

    return {
        scenarioId: isNullOrUndefinedOrEmpty(scenarioId) ? null : Number(scenarioId),
        projectionId: isNullOrUndefinedOrEmpty(projectionId) ? null : Number(projectionId),
        ownerId: isNullOrUndefinedOrEmpty(ownerId) ? null : Number(ownerId),
        entityId: Number(entityId),
    };
};
